<template>
  <header class="header">
    <router-link :to="{name: 'home'}">
      <div class="logo"></div>
    </router-link>
  </header>

</template>
<script>

  export default {}

</script>
<style lang="scss" scoped>


  $bar_height: 70px;
  $logo_width: 70px;

  header {
    width: 100%;
    height: $bar_height;
  }

  a {
    display: block;
    width: $logo_width;
    /*margin: 0 auto;*/ //真ん中寄せ
    margin: 1rem 2rem;
  }


  .logo {
    height: $bar_height;
    width: $logo_width;

    /*margin: 0 auto;*/

    background: {
      image: url("../../static/images/logo_white.svg");
      size: contain;
      repeat: no-repeat;
      position: center;
    }

    &:hover {
      background-size: 80%;
    }
  }

</style>



// WEBPACK FOOTER //
// Header.vue?4dff3de3